<template>
  <div v-if="this.$route.name">
    <v-admin-base
      v-if="app === 'admin'"
    />
    <v-organisation-base
      v-else-if="app === 'organisation'"
    />
    <v-reviewer-base
      v-else
    />
  </div>
</template>

<script>
import AdminBase from '@/admin/views/Base.vue';
import OrganisationBase from '@/organisation/views/Base.vue';
import ReviewerBase from '@/reviewer/views/Base.vue';

export default {
  name: 'App',
  components: {
    'v-admin-base': AdminBase,
    'v-organisation-base': OrganisationBase,
    'v-reviewer-base': ReviewerBase,
  },
  computed: {
    app() {
      return this.$route.meta.app;
    },
  },
  methods: {
    setTid() {
      if (!localStorage.getItem('tid')) {
        localStorage.setItem('tid', new Date().getTime());
      }
    },
  },
  created() {
    this.setTid();
    this.$forceUpdate();
  },
};
</script>
